import { render } from "./BulletinList.vue?vue&type=template&id=6cc20cca"
import script from "./BulletinList.vue?vue&type=script&lang=js"
export * from "./BulletinList.vue?vue&type=script&lang=js"

import "./BulletinList.vue?vue&type=style&index=0&id=6cc20cca&lang=css"

import exportComponent from "C:\\Users\\surface\\3D Objects\\Work\\schools\\inspire-school\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__